// src/utils/timeHelpers.js

/**
 * Wandelt Uhrzeit im Format "HH:MM AM/PM" in 24-Stunden-Zeit "HH:MM"
 * z.B. "06:32 PM" → "18:32", "05:52 AM" → "5:52"
 */
export function convertTo24Hour(time12h) {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
  
    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }
  
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  }
  

/**
 * Berechnet den Stundenoffset zwischen lokaler Zeit und API-Ortszeit
 * @param {string} locationTimeString z.B. "2025-03-30 14:00"
 * @returns {number} Offset-Stunden (z. B. +7 oder -3)
 
export function calculateHourOffset(locationTimeString) {
  const localDate = new Date();
  const locationDate = new Date(locationTimeString.replace(" ", "T"));

  // Zeitdifferenz in Millisekunden
  const diffInMs = locationDate.getTime() - localDate.getTime();

  // Umwandeln in Stunden (gerundet)
  return Math.round(diffInMs / (1000 * 60 * 60));
}*/